import BaseService from '@/features/BaseService';

export default class PriorityService extends BaseService {
  constructor() {
    super('priorities');
  }
}



// WEBPACK FOOTER //
// ./src/features/priority/PriorityService.js